import axios from "axios";
import { getTokenAccessor } from "@/lib/auth";
import { createResponseErrorInterceptor } from "@/lib/apiErrorInterceptor";

// Sarah-service base URL. Set via VITE_SARAH_SERVICE_BASE_URL:
//   - Empty/unset  → relative paths (Vite proxy in dev, or Amplify env in prod)
//   - Full URL     → direct calls (e.g. http://localhost:8080)
const SARAH_BASE: string = import.meta.env.VITE_SARAH_SERVICE_BASE_URL || "";

// gprtApi base URL includes /sarah/v1/gprt — path functions are relative to this
const BASE_URL = `${SARAH_BASE}/sarah/v1/gprt`;

export const gprtRequestsPath = (propertyId: string) =>
  `/properties/${propertyId}/requests`;

// `propertyId` is accepted but unused server-side — the config is a static,
// global constant list, not property-specific — pass any property on hand.
export const meetingRoomConfigPath = (propertyId: string) =>
  `/properties/${propertyId}/meeting-room/config`;

export const ATTACHMENT_PRE_UPLOAD_PATH = "/attachments/pre-upload";

export const gprtApi = axios.create({
  baseURL: BASE_URL,
  headers: {
    "Content-Type": "application/json",
  },
});

gprtApi.interceptors.request.use(
  (config) => {
    const token = getTokenAccessor();
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

gprtApi.interceptors.response.use(
  (response) => response,
  createResponseErrorInterceptor("group-pricing-requests API")
);
